class CollectionHeroBanner extends HTMLElement {
    constructor() {
        super();
        this.toggle = this.querySelector('details');
        this.bannerImage = this.querySelector('img');
        this.bannerText = this.querySelector('.collection-hero__text-wrapper');
        if (this.toggle) this.toggle.addEventListener('toggle', this.toggleView.bind(this));
    }

    toggleView() {
        if (!this.bannerImage || !this.bannerText) return;

        this.bannerImage.style.maxHeight = Math.max(this.bannerText.offsetHeight, 345) + 'px';
    }
}

customElements.define('collection-hero-banner', CollectionHeroBanner);
